"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ac_1 = require("@app/ac");
const manager_assistant_1 = require("@app/reducer/manager-assistant");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const mapStateToProps = (state) => {
    const { workspaceId, workspaces, calendarMultiSelect, positions } = state;
    const ws = workspaces.find((w) => w.id === workspaceId);
    return {
        // @ts-expect-error
        ws,
        calendarMultiSelect,
        positions,
    };
};
const mapDispatchToProps = (dispatch) => {
    return (0, redux_1.bindActionCreators)({
        createPlan: ac_1.createPlan,
        deleteCurrentPlan: ac_1.deleteCurrentPlan,
        closePlanning: manager_assistant_1.closedManagerAssistantPlanning,
        setModal: ac_1.setModal,
        setCalendarMultiSelect: ac_1.setCalendarMultiSelect,
    }, dispatch);
};
exports.default = (component) => {
    return (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(component);
};
